var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_123_24708",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 4H15.5L14.5 3H9.5L8.5 4H5V6H19M6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19V7H6V19Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4L14.4393 5.06066L14.8787 5.5H15.5V4ZM14.5 3L15.5607 1.93934L15.1213 1.5H14.5V3ZM9.5 3V1.5H8.87868L8.43934 1.93934L9.5 3ZM8.5 4V5.5H9.12132L9.56066 5.06066L8.5 4ZM5 4V2.5H3.5V4H5ZM5 6H3.5V7.5H5V6ZM6 19H4.5H6ZM18 7H19.5V5.5H18V7ZM6 7V5.5H4.5V7H6ZM19 2.5H15.5V5.5H19V2.5ZM16.5607 2.93934L15.5607 1.93934L13.4393 4.06066L14.4393 5.06066L16.5607 2.93934ZM14.5 1.5H9.5V4.5H14.5V1.5ZM8.43934 1.93934L7.43934 2.93934L9.56066 5.06066L10.5607 4.06066L8.43934 1.93934ZM8.5 2.5H5V5.5H8.5V2.5ZM3.5 4V6H6.5V4H3.5ZM5 7.5H19V4.5H5V7.5ZM4.5 19C4.5 19.9283 4.86875 20.8185 5.52513 21.4749L7.64645 19.3536C7.55268 19.2598 7.5 19.1326 7.5 19H4.5ZM5.52513 21.4749C6.1815 22.1313 7.07174 22.5 8 22.5V19.5C7.86739 19.5 7.74022 19.4473 7.64645 19.3536L5.52513 21.4749ZM8 22.5H16V19.5H8V22.5ZM16 22.5C16.9283 22.5 17.8185 22.1313 18.4749 21.4749L16.3536 19.3536C16.2598 19.4473 16.1326 19.5 16 19.5V22.5ZM18.4749 21.4749C19.1313 20.8185 19.5 19.9283 19.5 19H16.5C16.5 19.1326 16.4473 19.2598 16.3536 19.3536L18.4749 21.4749ZM19.5 19V7H16.5V19H19.5ZM18 5.5H6V8.5H18V5.5ZM4.5 7V19H7.5V7H4.5Z",
    fill: "#00266E",
    mask: "url(#path-1-inside-1_123_24708)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.cb3d5ab5b06c25e7be1fd8b04f35d375.svg";
export { ForwardRef as ReactComponent };